<template>
  <div>
    <div class="m-table-title">
      <div>{{  $t('routes.exception.403') }}</div>
    </div>
    <MdCard :dis-hover="true" noHeadBorder>
      <div slot="content">
        <div style="text-align:center">
          <h1 style="height: 600px;line-height:450px;font-size: 40px">{{  $t('routes.exception.403') }}</h1>
        </div>
      </div>
    </MdCard>
  </div>
</template>

<script>

    export default {
        name: "403",
        data() {
            return {};
        },
        mounted() {
        },
        methods: {}
    };
</script>
<style scoped lang="less">
</style>
